import React from "react";

const InventorySignUp = () => {
  return <div>InventorySignUp</div>;
};

export default InventorySignUp;
